import { jsxs, jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import { Modal } from '../Modal/Modal.js';
import { ModalBase } from '../ModalBase/ModalBase.js';
import css from './VideoPlayerModal.module.css.js';

const {
  CloseButton = () => null
} = Modal;
function VideoPlayerModal({
  isOpen,
  onDismiss,
  children
}) {
  return jsxs(ModalBase, {
    isOpen: isOpen,
    onDismiss: onDismiss,
    name: "video_player",
    overlayClassName: "bg-black bg-opacity-90 flex-col",
    contentClassName: "w-full",
    children: [jsx("div", {
      className: "flex w-full items-center",
      children: jsx("div", {
        className: "w-full",
        children: children
      })
    }), jsx("div", {
      className: clsx(css.closeButtonContainer, 'absolute p-xs'),
      children: jsx(CloseButton, {
        onClick: onDismiss,
        variant: "dark"
      })
    })]
  });
}

export { VideoPlayerModal };
